import heroBackground from "../assets/image1.png";
import About from "./About";
import Footer from "./Footer";
import WhyChooseUs from "./WhyChooseUs";
import { useNavigate } from "react-router-dom";

  

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* Hero Section */}
      <section
        className="position-relative d-flex align-items-center text-white overflow-hidden"
        style={{
          minHeight: "80vh",
          backgroundImage: `url(${heroBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Dark + Blur Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(3px)",
            zIndex: 0,
          }}
        ></div>

        {/* Text Content */}
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row">
            <div className="col-md-10 col-lg-8">
              <h1
                className="fw-bold mb-4"
                style={{
                  fontSize: "5rem",
                  lineHeight: "1.1",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 800,
                  textShadow: "0px 4px 10px rgba(0, 0, 0, 0.6)",
                }}
              >
                Find Home Service Near You
              </h1>

              <p
                className="mb-5"
                style={{
                  fontSize: "1.6rem",
                  maxWidth: "700px",
                  fontFamily: "'Open Sans', sans-serif",
                  fontWeight: 400,
                  color: "#f1f1f1",
                }}
              >
                Explore the best home services — Plumbing, Electrical, Cleaning, and More.
              </p>

             <button
  className="btn btn-lg px-5 py-3 text-white fw-semibold shadow-lg"

    style={{
    background: "linear-gradient(90deg, #4A90E2, #9013FE",
    borderRadius: "50px",
    fontSize: "1.3rem",
    fontFamily: "'Poppins', sans-serif",
  }}
  onClick={() => navigate("/services")}
>
  Our Services →
</button>

            </div>
          </div>
        </div>
      </section>

      {/* About Section with very small gap */}
      <section style={{ minHeight: "80vh" }}>
        <About />
      </section>

      {/* Why Choose Us Section with very small gap */}
     <section style={{ minHeight: "60vh" }}>
  <WhyChooseUs />
</section>


      <section>
          {/* 📱 Service 6 - Footer with WhatsApp */}
<div className="whatsapp-wrapper d-flex justify-content-center">
  <div className="whatsapp-section text-center py-5 px-4">
    <h3 className="fw-bold mb-3 text-white">
      Chat with Us on WhatsApp <br /> Get Instant Support
    </h3>
    <div className="d-flex justify-content-center">
      <a
        href="https://wa.me/94771234567" // replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        className="btn whatsapp-btn fw-bold px-4 py-2 d-flex align-items-center gap-2"
      >
        <i className="fa-brands fa-whatsapp"></i>
        Chat Now
      </a>
    </div>
  </div>
</div>

{/* Footer */}
<Footer />


      </section>
    </>
  );
};

export default HeroSection;
